import { Routes, Route, Link, Navigate } from 'react-router-dom';
import { useState, useContext, useEffect } from 'react';
import { LanguageContext } from '../../utils/lang_provider';
import { fetchData } from '../../utils/fetch';
import '../../styles/admin.css';
import '../../styles/admin_side_bar.css';
import Users from './user/user';
import { Dashboard } from './dashboard';
import WebObjects from './web_objects';
import ContentTablePage from './content/contentTablePage';
import CreateContentPage from './content/createContentPage';
import EditContentPage from './content/editContentPage';
import Newsletter from './newsletter';
import { Avatar, Flex, message } from 'antd';
import { UserOutlined } from '@ant-design/icons';
import EditTrainings from './content/editTrainings';
import Logout from './logout';

function AdminHeader() {
  const { language } = useContext(LanguageContext);
  const [ user, setUser ] = useState(null);

  useEffect(() => {
    async function loadUser() {
      try {
        const userRes = await fetchData(
          `admin/user/${localStorage.getItem("user")}`,
          language
        );

        const userId = userRes.id;
        setUser(userId);
      } catch (error) {
        message.error("Could not get user.")
      }
    }
    loadUser();
  }, [language]);

  return (
    <header className="Admin-header">
      <Flex style={{margin: "10px"}} justify='space-between' align='center'>
        <h1>NES Admin</h1>
        <Flex justify='center' align='center'>
          <Link to={`/admin/user/edit/${user}` }>
            <Avatar icon={<UserOutlined></UserOutlined>} style={{border: "1px solid rgb(128, 53, 53)", backgroundColor: "rgb(185, 78, 78)", marginRight: "20px"}}size={40}>USER</Avatar>
          </Link>
          <Logout></Logout>
        </Flex>
      </Flex>
    </header>
  );
}

function AdminSideBar() {
  const [menuItems, setMenuItems] = useState([]);
  const [openMenus, setOpenMenus] = useState(new Set());
  const { language } = useContext(LanguageContext);

  useEffect(() => {
    async function loadMenuItems() {
      try {
        const data = await fetchData(`admin/menu-items`, language);
        setMenuItems(data);
        data.forEach(item => {
          toggleMenu(item.id);
        });
      } catch (error) {
        console.error('Error loading menu items:', error);
      }
    }
    loadMenuItems();
  }, [language]);

  const toggleMenu = (id) => {
    setOpenMenus((prevOpenMenus) => {
      const newOpenMenus = new Set(prevOpenMenus);
      if (newOpenMenus.has(id)) {
        newOpenMenus.delete(id);
      } else {
        newOpenMenus.add(id);
      }
      return newOpenMenus;
    });
  };

  return (
    <div className="admin-side-bar">
      <ul>
        {menuItems.filter(item => item.level === 0).map(item => (
          <li key={item.id}>
            {menuItems.filter(child => child.parent_id === item.id).length > 0 ? (
              <div>
                <Link to="#" onClick={() => toggleMenu(item.id)}>
                  <div>
                    {item.options ? <i className="material-icons">{item.options}</i> : ""}
                    <span>{item.title}</span>
                  </div>
                  <i className={`material-icons dropdown ${openMenus.has(item.id) ? 'open' : ''}`}>
                    arrow_drop_down
                  </i>
                </Link>
                <ul className={`children ${openMenus.has(item.id) ? 'show' : ''}`}>
                  {menuItems.filter(child => child.parent_id === item.id).map(child => (
                    <li key={child.id}>
                      <Link to={"/" + child.link}>{child.title}</Link>
                    </li>
                  ))}
                </ul>
              </div>
            ) : (
              <Link to={"/" + item.link}>
                <div>
                  {item.options ? <i className="material-icons">{item.options}</i> : ""}
                  <span>{item.title}</span>
                </div>
              </Link>
            )}
          </li>
        ))}
      </ul>
    </div>
  );
}

function AdminBody() {
  return (
    <main className="Admin-body">
      <link href='https://fonts.googleapis.com/css?family=Montserrat' rel='stylesheet'/>
      <link href="https://fonts.googleapis.com/icon?family=Material+Icons" rel="stylesheet" />
      <Routes>
        <Route path="/" element={<Navigate to="site/dashboard"/>}/>
        <Route path="content/trainingOffers/create" element={<EditTrainings isOffer={true} />} />
        <Route path="content/trainings/create" element={<EditTrainings isOffer={false} />} />
        <Route path="content/:type/list" element={<ContentTablePage />} />
        <Route path="content/:type/create" element={<CreateContentPage />} />
        <Route path="content/trainingOffers/edit/:id" element={<EditTrainings isOffer={true}/>} />
        <Route path="content/trainings/edit/:id" element={<EditTrainings isOffer={false}/>} />
        <Route path="content/:type/edit/:id" element={<EditContentPage/>} />
        <Route path="site/dashboard/*" element={<Dashboard />} />
        <Route path="user/*" element={<Users />} />
        <Route path="settings/*" element={<Settings />} />
        <Route path="webObject/*" element={<WebObjects />} />
        <Route path="newsletter/export" element={<Newsletter />} />
      </Routes>
    </main>
  );
}

function AdminFooter() {
  return (
    <footer className="Admin-footer">
      <p>© 2025 NES Nová Dubnica s.r.o. All rights reserved.</p>
    </footer>
  );
}

export default function Admin() {
  return (
    <div className="Admin-root">
      <AdminSideBar />
      <div className="admin-main">
        <AdminHeader />
        <AdminBody />
        <AdminFooter />
      </div>
    </div>
  );
}

function Settings() {
  return <h2>Admin Settings</h2>;
}